import { Col, Nav, NavItem, NavLink, Row, Spinner, TabContent } from "reactstrap";
import { useTranslation } from "react-i18next";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { useEffect, useState } from "react";
import ExpenseCategories from "./Tabs/ExpenseCategories";
import { get } from "../../../../utils/helpers/api";
import ExpenseVendors from "./Tabs/ExpenseVendors";

function SettingsPage() {
  const { t } = useTranslation();
  const TABS = [
    { id: 'expense-categories', label: t('accounting.expenseCategories') },
    { id: 'expense-vendors', label: t('accounting.expenseVendors') }
  ];
  const [activeTab, setActiveTab] = useState('expense-categories');
  const [loading, setLoading] = useState(false);
  const [expenseCategories, setExpenseCategories] = useState(null);
  const [expenseVendors, setExpenseVendors] = useState(null);

  const getSettingsData = async () => {
    setLoading(true);
    const data = await get('/accounting/settings');
    if(data?.success) {
      setExpenseCategories(data?.expense_categories);
      setExpenseVendors(data?.expense_vendors);
    }
    setLoading(false);
  }

  useEffect(() => {
    getSettingsData();
  }, []);

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('settings.title')} />

        <div className="subheader-page-content scrollable">
          <Row className="align-items-start">
            <Col lg="2">
              <Nav pills vertical className="flex-column pref-nav">
                {TABS.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      active={activeTab === tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className="cursor-pointer"
                    >
                      {tab.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Col>

            <Col lg="10">
              {loading ?
                <Spinner color="primary" className="d-block mx-auto my-4" />
              :
                <TabContent activeTab={activeTab} className="pref-tab-content">
                  <ExpenseCategories 
                    categories={expenseCategories} 
                    refreshCategories={getSettingsData} 
                  />

                  <ExpenseVendors 
                    vendors={expenseVendors} 
                    refreshVendors={getSettingsData} 
                  />
                </TabContent>
              }
            </Col>
          </Row>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default SettingsPage;